module.exports = __webpack_public_path__ + "img/logo.fd6a9614.png";